<template>
  <div>
    <div class="fixed-bottom bg-secondary text-white" v-if="canEditArtists">
      <div class="container py-2">
        <div class="row" v-if="!loading">
          <div class="col-2 col-md-4">
            <img style="max-width:25px; filter:invert(1);" class="mr-2" src="/assets/img/nova.png"/>
            <span class="d-none d-md-inline">A10 Admin Bar</span>
          </div>
          <div class="col-10 col-md-8">
            <ul class="list-unstyled">
              <li class="float-left mr-3" v-if="canEditArtists">
                <a class="font-weight-bold text-white nounderline" target="_blank"
                   :href="'/nova/resources/artists/'+results.artist.id+'/edit'">Edit Artist</a>
              </li>
              <li class="float-left mr-3" v-if="canEditArtists">
                <a class="font-weight-bold text-white nounderline" target="_blank"
                   :href="'/nova/resources/artists/'+results.artist.id">Artist Details</a>
              </li>
            </ul>

          </div>
        </div>
        <div class="loader center-vertically" v-if="loading">
          <svg version="1.1" id="da-loader" xmlns="http://www.w3.org/2000/svg" fill="#fff"
               xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px"
               viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
        <path fill="#fff"
              d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path>
      </svg>
        </div>
      </div>
    </div>
    <!-- header start -->
    <div class="bg-light">
      <div class="col-lg-10 offset-lg-1">
        <div class="row">
          <div class="col-sm-12">
            <h4 class="mt-5 header_decoration position-relative pb-2 d-inline-block">{{ results.artist.firstname }}
              {{ results.artist.lastname }}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 mb-4 text-justify align-self-center">
            <p v-if="artistLifeSpan">
              {{ artistLifeSpan }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 mb-4 text-justify align-self-center">
            <span v-if="results.artist.short_description">
              {{ results.artist.short_description }}
              </span>
          </div>
        </div>

      </div>
      <!-- header end -->
    </div>
    <div v-if="results.hits > 0" class="col-lg-10 offset-lg-1 mt-3 mb-1 mb-md-5">
      <div class="d-flex justify-content-start" v-if="window.innerWidth < 960">
        <a
            id="filtersToggle"
            class="text-uppercase h7 py-2 ml-3"
            @click="filtersHidden = !filtersHidden"
        ><u>{{ __('show_hide_filters') }}</u></a>
      </div>
      <div
          v-if="!filtersHidden"
          :class="{filtersHidden : 'd-none'}"
          id="filtersToolbar"
          class="d-md-block toolbar justify-content-between offset-lg-1 col-lg-10 my-4"
      >
        <div class="row">
          <div class="col-lg-3 mb-sm-3">
            <h6 class="h7 text-uppercase text-muted"> {{ __('filter_lots_by') }} </h6>
            <select v-model="filter_by"
                    class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0"
                    name="search-filter-lots">
              <option :value="v" v-for="v in search_filter_by_options" :key="'filter-'+v">{{ __(v) }}</option>
            </select>
          </div>
          <div class="col-lg-3 mb-sm-3">
            <h6 class="h7 text-uppercase text-muted"> {{ __('order_lots_by') }} </h6>
            <select v-model="order_by"
                    class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0"
                    name="search-order-lots">
              <option :value="v" v-for="v in search_order_by_options" :key="'order-'+v">{{ __(v) }}</option>
            </select>
          </div>
          <div class="col-lg-3 mb-sm-3">
            <h6 class="h7 text-uppercase text-muted"> {{ __('lots_per_page') }} </h6>
            <select v-model="show_per_page"
                    class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0"
                    name="search-lots-per-page">
              <option v-if="v <= results.hits" :value="v" v-for="v in per_page_options" :key="'pp-'+v">{{ v }}</option>
              <option v-if="results.hits <= Math.max.apply(Math, this.per_page_options)" :value="results.hits">
                {{ __('all') }} ({{
                  results.hits
                }})
              </option>
            </select>
          </div>
          <div class="col-lg-3 d-flex flex-column">
            <h6 class="h7 text-uppercase text-muted"> {{ __('lots_on_page') }} </h6>
            <p>{{ results.hits }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="d-flex justify-content-center my-4" v-if="loading">
        <div class="loader">
          <svg
              version="1.1"
              id="da-loader"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="40px"
              height="40px"
              viewBox="0 0 50 50"
              style="enable-background:new 0 0 50 50;"
              xml:space="preserve"
          >
        <path
            fill="#000"
            d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
        >
          <animateTransform
              attributeType="xml"
              attributeName="transform"
              type="rotate"
              from="0 25 25"
              to="360 25 25"
              dur="0.6s"
              repeatCount="indefinite"
          />
        </path>
      </svg>
        </div>
      </div>

      <!-- no results start -->
      <div v-if="results.hits == 0 && !loading" class="container">
        <div class="row">
          <div class="col-sm-12 mt-4 mb-4" style="text-align: center;">
            <p> {{ __('no-results') }}</p>
            <a :href="results.noHitsLink"
               style="padding-left: 0px;color:blue;text-decoration: underline">{{ __('auctions-current') }}</a>
          </div>
        </div>
      </div>
      <!-- no results end -->

      <!-- lot findings start -->
      <div v-if="results.hits > 0 && !loading" class="row" id="searchResults" style="width: 100%">
        <lot
            v-if="lot.status === 1"
            :auction="lot.auction"
            :lot="lot"
            :key="lot.id"
            v-for="lot in lotsToShow"
        />
      </div>
    </div>
    <div v-if="results.hits > 0 && !loading" class="container">
      <div class="row pagination">
        <div class="col-1"></div>
        <div class="col text-center my-3">
          <nav aria-label="labels" style="background: white !important;">
            <ul class="pagination justify-content-center mb-5">
              <li class="page-item prev" :class="hasPrevious">
                <button @click="changePage('prev')" class="page-link" :aria-label="__('prevpage')">
                  <svg
                      width="40"
                      height="40"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <polyline fill="none" stroke="#000" stroke-width=".5"
                              points="13 16 7 10 13 4"/>
                  </svg>
                </button>
              </li>
              <li class="page-item" :class="isCurrentPage(p)" v-for="p in proximityPages" :key="'page-'+p">
                <button @click="changePage(p)" class="page-link" :aria-label="__('page')"
                >{{ p }}
                </button>
              </li>
              <li class="page-item next" :class="hasNext">
                <button @click="changePage('next')" class="page-link" :aria-label="__('nextpage')">
                  <svg
                      width="40"
                      height="40"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <polyline fill="none" stroke="#000" stroke-width=".5"
                              points="7 4 13 10 7 16"/>
                  </svg>
                </button>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-1"></div>
      </div>
    </div>

  </div>
</template>

<script>
import {APP} from "../constants.js";

export default {
  props: ["results"],

  data: function () {
    return {
      filtersHidden: false,
      loading: false,
      lotIds: [],        // chunked list after filter+sort
      lotsToShow: [],    // API response for current page
      page: 1,
      perPage: 9,
      ordering: 'LOT_DATE',
      filtering: 'all'
    }
  },

  computed: {
    artistLifeSpan: function () {
      const a = this.results && this.results.artist
      if (!a) return ''

      let text = ''

      if (a.birth_date && a.birth_date != 0) {
        text += a.birth_date

        if (a.birth_place) {
          text += ', ' + a.birth_place
        }

        if (a.death_date && a.death_date != 0) {
          text += ' - ' + a.death_date

          if (a.death_place) {
            text += ', ' + a.death_place
          }
        }
      }

      return text
    },
    canEditArtists: function () {
      return window.AG.caneditartists;
    },
    window: () => window,

    per_page_options: function () {
      return APP.LOTS_PER_PAGE.VALUES;
    },

    search_order_by_options: function () {
      return ['LOT_DATE', 'LOT_PRICE_ASC', 'LOT_PRICE_DESC'];
    },

    search_filter_by_options: function () {
      return ['LOT_SOLD', 'LOT_UNSOLD', 'all'];
    },

    pages: function () {
      const start = 1;
      const end = this.totalPages();
      if (end < 1) {
        return [];
      }

      return Array(end - start + 1)
          .fill()
          .map((item, index) => start + index);
    },

    hasPrevious: function () {
      return this.currentPage <= 1 ? "disabled" : "";
    },

    hasNext: function () {
      return this.currentPage >= this.totalPages() ? "disabled" : "";
    },

    nextPage: function () {
      return parseInt(this.currentPage) + 1;
    },

    prevPage: function () {
      return parseInt(this.currentPage) - 1;
    },

    currentPage: function () {
      return parseInt(this.page || 1);
    },

    show_per_page: {
      get: function () {
        return this.perPage;
      },
      set: function (show) {
        const parsed = parseInt(show, 10);
        this.perPage = Number.isFinite(parsed) && parsed > 0 ? parsed : 9;
        this.setUrlParams('per_page', this.perPage);
        this.applyFilterAndOrder({resetPage: true});
      }
    },

    filter_by: {
      get: function () {
        return this.filtering;
      },
      set: function (filter) {
        this.filtering = filter;
        this.setUrlParams('filter_by', filter);
        this.applyFilterAndOrder({resetPage: true});
      }
    },

    order_by: {
      get: function () {
        return this.ordering;
      },
      set: function (order) {
        this.ordering = order;
        this.setUrlParams('order_by', order);
        this.applyFilterAndOrder({resetPage: true});
      }
    },

    proximityPages() {
      const curr = parseInt(this.currentPage || 1, 10);
      const total = this.totalPages();

      if (!total) {
        return [];
      }

      return [
        curr - 3,
        curr - 2,
        curr - 1,
        curr,
        curr + 1,
        curr + 2,
        curr + 3
      ].filter((value) => value > 0 && value <= total);
    },
  },

  methods: {
    // ===== status constants for frontend filtering =====
    statusSold() {
      return 1;
    },

    statusUnsold() {
      return 2;
    },

    statusSoldPost() {
      return 5;
    },

    statusUpcoming() {
      return 0;
    },

    // ===== helpers =====
    flattenLotChunks(arr) {
      if (!Array.isArray(arr)) return [];
      return arr.reduce((acc, chunk) => {
        if (Array.isArray(chunk)) {
          return acc.concat(chunk);
        }
        return acc;
      }, []);
    },

    chunkArray(arr, size) {
      const source = Array.isArray(arr) ? arr.slice() : [];
      const chunkSize = Math.max(1, parseInt(size, 10) || 1);
      const out = [];

      for (let i = 0; i < source.length; i += chunkSize) {
        out.push(source.slice(i, i + chunkSize));
      }

      return out;
    },

    getItemId(item) {
      return Object.keys(item)[0];
    },

    getMeta(item) {
      return item[this.getItemId(item)];
    },

    getAuctionStatus(item) {
      return Number(this.getMeta(item).auction_status);
    },

    getDefaultOrder(item) {
      const n = Number(this.getMeta(item).default_order);
      return Number.isFinite(n) ? n : 0;
    },

    getSortingPrice(item) {
      const raw = this.getMeta(item).sorting_price;

      if (raw === null || raw === undefined || raw === '') {
        return null;
      }

      const n = Number(raw);
      return Number.isFinite(n) ? n : null;
    },
    totalPages() {
      const count = this.countFilteredLots();
      const perPage = Math.max(1, parseInt(this.show_per_page, 10) || 1);
      return Math.ceil(count / perPage);
    },

    countFilteredLots() {
      if (!Array.isArray(this.lotIds) || this.lotIds.length === 0) {
        return 0;
      }

      return this.flattenLotChunks(this.lotIds).length;
    },

    comparePriceAsc(a, b) {
      const av = this.getSortingPrice(a);
      const bv = this.getSortingPrice(b);

      // Nulls/missing prices always last
      if (av === null && bv === null) {
        return this.getDefaultOrder(a) - this.getDefaultOrder(b);
      }
      if (av === null) return 1;
      if (bv === null) return -1;

      const diff = av - bv;
      if (diff !== 0) return diff;

      return this.getDefaultOrder(a) - this.getDefaultOrder(b);
    },

    comparePriceDesc(a, b) {
      const av = this.getSortingPrice(a);
      const bv = this.getSortingPrice(b);

      // Nulls/missing prices always last
      if (av === null && bv === null) {
        return this.getDefaultOrder(a) - this.getDefaultOrder(b);
      }
      if (av === null) return 1;
      if (bv === null) return -1;

      const diff = bv - av;
      if (diff !== 0) return diff;

      return this.getDefaultOrder(a) - this.getDefaultOrder(b);
    },

    compareDefaultOrder(a, b) {
      // Fixes the old bug (it used + instead of -)
      return this.getDefaultOrder(a) - this.getDefaultOrder(b);
    },

    applyFilterAndOrder({resetPage = true} = {}) {
      let flat = this.flattenLotChunks(this.results.lotIds);

      flat = flat.filter(item => {
        const auctionStatus = this.getAuctionStatus(item);
        const soldLike = this.isSoldLike(item);

        switch (this.filtering) {
          case 'LOT_SOLD':
            return soldLike;

          case 'LOT_UNSOLD':
            return auctionStatus === this.statusUnsold() && !soldLike;

          case 'all':
          default:
            return (
                soldLike ||
                auctionStatus === this.statusUnsold() ||
                auctionStatus === this.statusUpcoming() // UPCOMING included in ALL
            );
        }
      });

      switch (this.ordering) {
        case 'LOT_PRICE_ASC':
          flat.sort((a, b) => this.comparePriceAsc(a, b));
          break;

        case 'LOT_PRICE_DESC':
          flat.sort((a, b) => this.comparePriceDesc(a, b));
          break;

        case 'LOT_DATE':
        default:
          flat.sort((a, b) => this.compareDefaultOrder(a, b));
          break;
      }

      this.lotIds = this.chunkArray(flat, this.perPage);

      // After filter/order/perPage changes, reset to page 1
      if (resetPage) {
        this.changePage(1);
        return;
      }

      // Keep current page if possible, clamp otherwise
      const totalPages = this.totalPages();
      const targetPage = Math.min(Math.max(parseInt(this.page || 1, 10), 1), Math.max(totalPages, 1));
      this.changePage(targetPage);
    },

    unSetUrlParams(param) {
      const objectURL = new URL(location.href);
      objectURL.searchParams.delete(param);
      window.history.replaceState({path: objectURL.toString()}, '', objectURL.toString());
    },

    setUrlParams(param, value) {
      const objectURL = new URL(location.href);
      const stringValue = String(value);

      objectURL.searchParams.set(param, stringValue);

      const minPerPage = String(Math.min.apply(Math, this.per_page_options));

      // Remove defaults to keep URL clean
      if (param === 'page' && stringValue === '1') {
        objectURL.searchParams.delete('page');
      }

      if (param === 'filter_by' && stringValue === 'all') {
        objectURL.searchParams.delete('filter_by');
      }

      if (param === 'per_page' && stringValue === minPerPage) {
        objectURL.searchParams.delete('per_page');
      }

      if (param === 'order_by' && stringValue === 'LOT_DATE') {
        objectURL.searchParams.delete('order_by');
      }

      window.history.replaceState({path: objectURL.toString()}, '', objectURL.toString());
    },

    changePage: function (p) {
      let next = p;

      const totalPages = this.totalPages();

      if (next === 'next') {
        next = this.currentPage + 1;
      } else if (next === 'prev') {
        next = this.currentPage - 1;
      }

      next = parseInt(next, 10);
      if (!Number.isFinite(next)) {
        next = 1;
      }

      if (totalPages === 0) {
        this.page = 1;
        this.lotsToShow = [];
        this.loading = false;
        this.unSetUrlParams('page');
        return;
      }

      if (next < 1) next = 1;
      if (next > totalPages) next = totalPages;

      this.page = next;
      this.setUrlParams('page', next);
      this.getLotsToShow(next - 1);
    },
    isSoldLike(item) {
      const meta = this.getMeta(item);

      // Prefer backend-computed truth
      if (meta && Object.prototype.hasOwnProperty.call(meta, 'is_sold_like')) {
        return Number(meta.is_sold_like) === 1;
      }

      // Fallback (defensive)
      const auctionStatus = Number(meta.auction_status);
      const shopStatus = Number(meta.shop_status);

      return auctionStatus === this.statusSold()
          || auctionStatus === this.statusSoldPost()
          || (auctionStatus === this.statusUnsold() && shopStatus === 2);
    },

    getLotsToShow: function (p) {
      const pageLots = (Array.isArray(this.lotIds) && this.lotIds[p]) ? this.lotIds[p] : [];
      const lotIds = pageLots.map(item => Object.keys(item)[0]);

      if (!lotIds.length) {
        this.lotsToShow = [];
        this.loading = false;
        this.scrollToTop();
        return;
      }

      this.loading = true;
      this.lotsToShow = [];

      axios.post(`/api/get-lots-by-id`, {
        lotIds: lotIds,
        locale: this.results.locale
      })
          .then(response => {
            this.lotsToShow = response.data || [];
            this.loading = false;
            this.scrollToTop();
          })
          .catch(err => {
            console.log(err);
            this.lotsToShow = [];
            this.loading = false;
          });
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    locale: function () {
      return this.results.locale;
    },

    toggleMore: function () {
      this.more = !this.more;
    },

    open_link: function (url) {
      window.open(url, "_blank");
    },

    trim: function (value) {
      value = value.replace(/(^\s*)|(\s*$)/gi, "");
      value = value.replace(/[ ]{2,}/gi, " ");
      value = value.replace(/\n /, "\n");
      try {
        value = value.trimStart();
        value = value.trimEnd();
      } catch (err) {
        // suppress errors for trim
      }

      return value;
    },

    __: function (key) {
      return window.AG.trans[key];
    },

    __LIVE: function (key) {
      return window.AG.generic ? window.AG.generic[key] : key;
    },

    route: function (key) {
      return window.AG.routes[key];
    },

    goToLot: function (ev) {
      switch (ev.keyCode) {
        case 13: // enter
          if (this.lotJump) {
            var lot = this.lots.find(lot => lot.number == this.lotJump);
            if (lot != undefined) {
              this.$router.push({
                name: "lot",
                params: {
                  auction: this.auction.slug,
                  lot: lot.slug
                }
              });
            }
          }
          break;
        case 27: // escape
          this.lotJump = "";
          break;
      }
    },

    goToLotMobile: function () {
      if (this.lotJump) {
        var lot = this.lots.find(lot => lot.number == this.lotJump);
        if (lot != undefined) {
          this.$router.push({
            name: "lot",
            params: {
              auction: this.auction.slug,
              lot: lot.slug
            }
          });
        }
      }
    },

    isCurrentPage: function (page) {
      return this.currentPage == page ? "active" : "";
    },

    openShareModal: function (event) {
      var targetUrl = this.url;
      $('#shareModal').on('show.bs.modal', function (e) {
        $('#facebookShare').attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href + "&amp;display=popup")
      });
      event.preventDefault();
    },

    onResize() {
      this.filtersHidden = window.innerWidth < 960;
    },
  },

  created() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
    if (typeof window === 'undefined') return;
    window.removeEventListener('resize', this.onResize, {passive: true});
  },

  mounted() {
    window.addEventListener('resize', this.onResize, {passive: true});
    this.onResize();

    if (this.results.hits < 1) {
      return;
    }

    // defaults from backend
    this.lotIds = Array.isArray(this.results.lotIds) ? this.results.lotIds : [];

    const objectURL = new URL(location.href);

    // Initialize from URL only when allowed (keeping your original behavior)
    if (window.AG.canSeeBack) {
      if (objectURL.searchParams.has('filter_by')) {
        const candidate = objectURL.searchParams.get('filter_by');
        if (this.search_filter_by_options.includes(candidate)) {
          this.filtering = candidate;
        }
      } else {
        this.unSetUrlParams('filter_by');
      }

      if (objectURL.searchParams.has('order_by')) {
        const candidate = objectURL.searchParams.get('order_by');
        if (this.search_order_by_options.includes(candidate)) {
          this.ordering = candidate;
        }
      } else {
        this.unSetUrlParams('order_by');
      }

      if (objectURL.searchParams.has('per_page')) {
        const candidate = parseInt(objectURL.searchParams.get('per_page'), 10);
        if (Number.isFinite(candidate) && candidate > 0) {
          this.perPage = candidate;
        }
      } else {
        this.perPage = parseInt(this.results.perPage, 10) || 9;
        this.unSetUrlParams('per_page');
      }

      if (objectURL.searchParams.has('page')) {
        const candidate = parseInt(objectURL.searchParams.get('page'), 10);
        if (Number.isFinite(candidate) && candidate > 0) {
          this.page = candidate;
        }
      } else {
        this.page = parseInt(this.results.pageNo, 10) || 1;
        this.unSetUrlParams('page');
      }
    } else {
      this.filtering = 'all';
      this.ordering = 'LOT_DATE';
      this.perPage = parseInt(this.results.perPage, 10) || 9;
      this.page = parseInt(this.results.pageNo, 10) || 1;

      this.unSetUrlParams('filter_by');
      this.unSetUrlParams('order_by');
      this.unSetUrlParams('per_page');
      this.unSetUrlParams('page');
    }

    // Build filtered/sorted/chunked list and load current (clamped) page
    this.applyFilterAndOrder({resetPage: false});
  },

  updated() {
  }
};
</script>